import { ErrorMessage, Formik } from "formik";
import React, { useState } from "react";
import {
  Button,
  Col,
  Form,
  FormCheck,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch, useSelector } from "react-redux";
import { formatDateYMD } from "../../../../utils/dateFormatter";

import "./phoneInput.scss";
import { updateUserStart } from "../../../../store/redux-slices/tenantUsers";
import { userSchema } from "./schema";

const EditUserModal = ({ show, setShow, userData, isTenant = false }) => {
  const { countries, tenantCountries } = useSelector((state) => state.fetch);
  const { isUpdateUserLoading } = useSelector((state) => state.tenantUsers);
  const dispatch = useDispatch();
  const [phoneError, setPhoneError] = useState("");

  const country = isTenant ? tenantCountries?.rows : countries;

  const showData = [
    { label: "Email", value: "email", isDisabled: true },
    { label: "First Name", value: "firstName", isDisabled: false },
    { label: "Last Name", value: "lastName", isDisabled: false },
    { label: "User Name", value: "username" , isDisabled: true},
    { label: "Address", value: "address", isDisabled: false },
  ];

  const successToggle = (resetForm) => {
    resetForm({ formValues: "" });
    setShow(false);
  };

  const validatePhone = (phone, country) => {
    if (!phone || phone.length < 7) {
      return "Phone number is required and must be at least 7 digits";
    }

    // Check if phone starts with 0 after country code
    const phoneWithoutCountryCode = phone.substring(country.dialCode.length);
    if (phoneWithoutCountryCode.charAt(0) === "0") {
      return "Phone number should not start with 0 after country code";
    }

    // Updated length validation - max 10 digits for phone number part
    if (
      phoneWithoutCountryCode.length < 6 ||
      phoneWithoutCountryCode.length > 10
    ) {
      return "Phone number must be between 6 and 10 digits";
    }

    return "";
  };

  console.log({userData} , "userDatauserDatauserDatauserData")

  function normalizeGender(value) {
    if (!value) return ''; // handle empty/null safely
  
    const val = value.toString().trim().toLowerCase();
  
    if (val === 'f' || val === 'female') {
      return 'Female';
    } else if (val === 'm' || val === 'male') {
      return 'Male';
    }
    else if (val === 'other') {
      return 'Other';
    }
  
    return ''; // or return some default if needed
  }
  
  

  return (
    <>
      <Formik
        initialValues={{
          userId: userData?.userId,
          firstName: userData?.firstName,
          lastName: userData?.lastName,
          username: userData?.username,
          email: userData?.email,
          countryCode: userData?.countryCode,
          address: userData?.address,
          zipCode: userData?.zipCode,
          dateOfBirth: formatDateYMD(userData?.dateOfBirth),
          gender: userData?.gender,
          currencyCode: userData?.currencyCode,
          phoneCode: userData?.phoneCode || "",
          phone: userData?.phone || "",
          profileNotes: userData?.profileNotes || ""
        }}
        validationSchema={userSchema}
        onSubmit={(formValues, { resetForm }) => {
          if (phoneError) {
            return;
          }

          dispatch(
            updateUserStart({
              data: {...formValues , gender : normalizeGender(formValues.gender)},
              isTenant,
              successToggle,
              resetForm,
            })
          );
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          touched,
          setFieldValue,
          setFieldTouched,
          errors,
        }) => (
          <Modal
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            keyboard={false}
            size="xl"
          >

            <Modal.Header closeButton>
              {console.log({errors, values,} , "gendergendergendergender")}
              <h5>
              Update {userData?.firstName} {userData?.lastName} (
                {userData?.email}) Info
              </h5>
            </Modal.Header>
            <Modal.Body>
              <Row>
                {showData?.map(({ label, value , isDisabled}) => (
                  <Col xs={6} key={value} className="mt-3">
                    <Form.Label>{label}</Form.Label>
                    <Form.Control
                      name={value}
                      type="text"
                      placeholder={`Enter ${label}`}
                      value={values[value]}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={isDisabled}
                      isInvalid={touched[value] && errors[value]}
                    />
                    <ErrorMessage
                      component="div"
                      name={value}
                      className="text-danger"
                    />
                  </Col>
                ))}

                <Col xs={6} className="mt-3">
                  <Form.Label>Phone Number</Form.Label>

                  <div className="phone-input-container">
                    <PhoneInput
                      country={
                        values.countryCode
                          ? values.countryCode.toLowerCase()
                          : "us"
                      }
                      value={`${values.phoneCode}${values.phone}`}
                      onChange={(phone, country) => {
                        const dialCode = "+" + country.dialCode;
                        const phoneNumber = phone.substring(
                          country.dialCode.length
                        );

                        // Only allow digits and limit to 10 digits max
                        const cleanPhoneNumber = phoneNumber.replace(/\D/g, '').slice(0, 10);

                        setFieldValue("phoneCode", dialCode);
                        setFieldValue("phone", cleanPhoneNumber);
                        setFieldValue(
                          "countryCode",
                          country.countryCode.toUpperCase()
                        );

                        // Reconstruct the full phone number for validation
                        const fullPhoneForValidation = country.dialCode + cleanPhoneNumber;
                        const error = validatePhone(fullPhoneForValidation, country);
                        setPhoneError(error);
                      }}
                      onBlur={() => setFieldTouched("phone", true)}
                      enableSearch={true}
                      searchPlaceholder="Search countries"
                      placeholder="Enter phone number" countryCodeEditable={false}
                      preferredCountries={[
                        "us",
                        "gb",
                        "ca",
                        "au",
                        "de",
                        "fr",
                        "in",
                      ]}
                      autoFormat={true}
                      enableLongNumbers={false}
                      disableDropdown={false}
                      searchNotFound="No countries found"
                      inputProps={{
                        onKeyPress: (e) => {
                          // Only allow numbers
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        },
                        onInput: (e) => {
                          // Remove any non-digit characters and limit to country code + 10 digits
                          const value = e.target.value.replace(/\D/g, '');
                          const countryCodeLength = e.target.value.match(/^\+?\d+/)?.[0]?.replace('+', '').length || 0;

                          // Find the country code length dynamically
                          const currentCountry = values.countryCode?.toLowerCase() || 'us';
                          const phoneInputElement = e.target;
                          const countryData = phoneInputElement.closest('.react-tel-input')?.querySelector('.selected-flag')?.getAttribute('title');

                          // Extract just the phone number part (after country code)
                          const phoneNumberPart = value.substring(values.phoneCode?.replace('+', '').length || 0);

                          if (phoneNumberPart.length > 10) {
                            e.target.value = values.phoneCode?.replace('+', '') + phoneNumberPart.slice(0, 10);
                          }
                        }
                      }}
                    />

                    {phoneError && (
                      <div className="invalid-feedback d-block">{phoneError}</div>
                    )}

                    {!phoneError && values.phone && values.phone.length > 0 && (
                      <div className="valid-feedback d-block">
                        Phone number is valid
                      </div>
                    )}

                    {/* {!values.phone && (
                      <div className="text-danger">
                        Select country and enter your phone number
                      </div>
                    )} */}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xs={6} className="mt-3">
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    name="dateOfBirth"
                    type="date"
                    value={values.dateOfBirth}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.dateOfBirth && errors.dateOfBirth}
                  />
                  <ErrorMessage
                    component="div"
                    name="dateOfBirth"
                    className="text-danger"
                  />
                </Col>

                <Col xs={6} className="mt-3">
                  <Form.Label>Zip Code</Form.Label>
                  <Form.Control
                    name="zipCode"
                    type="text"
                    placeholder="Enter Zip Code"
                    value={values.zipCode}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.zipCode && errors.zipCode}
                  />
                  <ErrorMessage
                    component="div"
                    name="zipCode"
                    className="text-danger"
                  />
                </Col>
              </Row>

              <Row className="mt-3">
                <Col>
                  <Form.Label className="me-2">Gender</Form.Label>
                  <div className="d-flex gap-3 mt-2">
                    <Form.Check
                      type="radio"
                      id="Male"
                      name="gender"
                      label="Male"
                      value="Male"
                      checked={values?.gender === "Male" || values?.gender === "M" || values?.gender === "male"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <Form.Check
                      type="radio"
                      id="Female"
                      name="gender"
                      label="Female"
                      value="Female"
                      checked={values?.gender === "Female" || values?.gender === "F" || values?.gender === "female"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />

<Form.Check
                      type="radio"
                      id="Other"
                      name="gender"
                      label="Other"
                      value="Other"
                      checked={values?.gender === "other" || values?.gender === "Other"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />


                  </div>
                  <ErrorMessage
                    component="div"
                    name="gender"
                    className="text-danger"
                  />
                </Col>

                <Col xs={6} className="">
                  <Form.Label>User Notes</Form.Label>
                  <Form.Control
                    name="profileNotes"
                    as="textarea"
                    rows={15} 
                    placeholder="Enter User Notes"
                    value={values.profileNotes}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{  minHeight: '70px'}}
                    isInvalid={touched.profileNotes && errors.profileNotes}
                  />
                  <ErrorMessage
                    component="div"
                    name="profileNotes"
                    className="text-danger"
                  />
                </Col>

              </Row>

            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-between align-items-center">
              <Button
                variant="outline-secondary"
                onClick={() => setShow(false)}
                disabled={isUpdateUserLoading}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={isUpdateUserLoading || phoneError}
              >
                {isUpdateUserLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Updating...
                  </>
                ) : (
                  "Update User"
                )}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>
    </>
  );
};

export default EditUserModal;
